<template>
  <modal :id="itemStatusModalId">
    <div class="add-user">
      <b-row>
        <b-col>
          <close-button
            class="float-right"
            @close-button-click="handleCloseBtnClick"
          />
        </b-col>
      </b-row>
      <h3>Add Item</h3>
      <b-row>
        <b-col>
          <b-img
            v-if="formFave && formFave.imgURL"
            :src="formFave.imgURL"
            fluid
            style="object-fit: contain"
            :alt="`My Memory with Derriana`"
          />
          <image-upload
            v-else
            ref="image-upload"
            class="photo-upload-wrapper"
            :img-upload-idx="idx"
            img-upload-type="photo"
            :storage-path="storagePath"
            :max-image="1"
            :show-edit="false"
            :show-delete="true"
            text-drag="Click to upload or drag photo memory (.png, .jpg) here. "
            @img-uploaded-url="handlePhotoUploadedURL"
          />
        </b-col>
        <b-col>
          <!-- NAME -->
          <b-form-group>
            <label-info
              v-if="false"
              id="form-name"
              label-name="Fave Name"
              label-info=""
            />
            <b-form-input
              v-model="formFave.name"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;"
              placeholder="Fave Name"
            />
          </b-form-group>
          <!-- URL -->
          <b-form-group>
            <label-info
              v-if="false"
              id="form-name"
              label-name="Fave URL"
              label-info=""
            />
            <b-form-input
              v-model="formFave.url"
              type="text"
              class="custom-input"
              style="
                    border-radius:50px;
                    padding:20px;"
              placeholder="Fave URL"
            />
          </b-form-group>
          <!-- DESCRIPTION (OPT)-->
          <b-form-group
            id="input-group-1"
            label="Description:"
            label-for="input-description"
            style="margin-top: 25px;"
            description="Copy and Paste"
          >
            <transition name="fadeHeight" mode="out-in">
              <editor
                id="textarea-default"
                v-show="formFave"
                @input="input"
                :clear="clear"
                :content="formFave.description"
                @resetClear="resetClear"
              />
            </transition>
          </b-form-group>
          <span class="error">
            <div v-for="(anError, i) in this.errors" :key="`err_${i}`">
              {{ anError }}
            </div>
          </span>
          <b-form-group>
            <b-button
              v-if="this.faveData && this.isUpdate"
              pill
              class="btn btn-success float-right"
              style="border: none; background-color: #fe818b; padding: 10px;"
              @click="handleUpdateFaveClick"
            >
              Update
              {{ formFave && formFave.name ? formFave.name : "your Fave" }}
            </b-button>
            <b-button
              v-else
              pill
              class="btn btn-success float-right"
              style="border: none; background-color: #fe818b; padding: 10px;"
              @click="handleAddFaveClick"
            >
              Add {{ formFave && formFave.name ? formFave.name : "your Fave" }}
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/common/modal";
import CloseButton from "@/components/common/closeButton";
import UploadImage from "@/mixins/UploadImage";
import VideoHandling from "@/mixins/VideoHandling";
import ImageUpload from "@/components/common/imageUpload";
import Editor from "@/components/common/editor";
import axios from "axios";
export default {
  name: "Admin_Manage_AddEditItem_Faves",
  mixins: [UploadImage, VideoHandling],
  components: {
    Modal,
    CloseButton,
    ImageUpload,
    Editor
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    itemStatusModalId: {
      type: String,
      default: "add-edit-item-status"
    },
    rootPathDoc: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {
    formData() {
      return this.entity && this.entity.form ? this.entity.form : null;
    }
  },
  created() {
    this.formReset();
  },
  mounted() {},
  methods: {
    handleAddItem() {
      this.isUpdate = false;
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleUpdateItem(faveData) {
      this.isUpdate = true;
      this.faveData = faveData;
      this.formFave = faveData && faveData.form ? _.clone(faveData.form) : {};
      this.$bvModal.show(this.itemStatusModalId);
    },
    handleCloseBtnClick() {
      this.entity = null;
      this.$bvModal.hide(this.itemStatusModalId);
    },
    handlePhotoUploadedURL(idx, url) {
      this.formFave.imgURL = url;
    },
    handleAddFaveClick() {
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("service/addItem", {
            rootPathDoc: this.rootPathDoc,
            itemType: "inventory",
            itemPayload: this.formFave,
            ip
          })
          .then(res => {
            this.$emit("item-added");
            this.handleCloseBtnClick();
            this.formReset();
          });
      });
    },
    handleUpdateFaveClick() {
      debugger;
      if (this.simpleValidate().length > 0) return;

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("user/updateFave", {
            id: this.faveData && this.faveData.id ? this.faveData.id : null,
            form: this.formFave,
            ip
          })
          .then(res => {
            this.$emit("item-added");
            this.handleCloseBtnClick();
            this.formReset();
          });
      });
    },
    simpleValidate() {
      this.errors = [];

      /* if (this.formFave && !this.validateEmail(this.formFave.email))
         this.errors.push("Please enter a valid email");*/

      if (
        (this.formFave && !this.formFave.name) ||
        this.formFave.name.length === 0
      )
        this.errors.push("Please enter fave name");

      if (
        (this.formFave && !this.formFave.url) ||
        this.formFave.url.length === 0
      )
        this.errors.push("URL is required");

      return this.errors;
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formReset() {
      this.formFave = null;
      this.formFave = this.formDefault;
    },
    handleSubmitANewMemory() {
      this.formReset();
      this.memorySubmitted = false;
    },
    input(val) {
      this.formFave.description = val.content;
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      clear: false,
      idx: 0,
      storagePath: "warehouse_inventory_imgs",
      isUpdate: false,
      faveData: null,
      formFave: null,
      formDefault: {
        name: null,
        description: [],
        brand: null,
        url: null,
        comment: null,
        imgURL: null
      },
      errors: [],
      entity: null
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
